var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3453 10C19.3453 10.2984 19.2268 10.5845 19.0158 10.7955C18.8049 11.0065 18.5187 11.125 18.2203 11.125H11.0953V18.25C11.0953 18.5484 10.9768 18.8345 10.7658 19.0455C10.5549 19.2565 10.2687 19.375 9.97034 19.375C9.67197 19.375 9.38582 19.2565 9.17484 19.0455C8.96386 18.8345 8.84534 18.5484 8.84534 18.25V11.125H1.72034C1.42197 11.125 1.13582 11.0065 0.924842 10.7955C0.713863 10.5845 0.595337 10.2984 0.595337 10C0.595337 9.70163 0.713863 9.41548 0.924842 9.2045C1.13582 8.99353 1.42197 8.875 1.72034 8.875H8.84534V1.75C8.84534 1.45163 8.96386 1.16548 9.17484 0.954505C9.38582 0.743526 9.67197 0.625 9.97034 0.625C10.2687 0.625 10.5549 0.743526 10.7658 0.954505C10.9768 1.16548 11.0953 1.45163 11.0953 1.75V8.875H18.2203C18.5187 8.875 18.8049 8.99353 19.0158 9.2045C19.2268 9.41548 19.3453 9.70163 19.3453 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b697424adb854e700b7ade834f32cd01.svg";
export { ForwardRef as ReactComponent };